/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CommerceInputs */

const en_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce`)
};

const es_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comercio`)
};

const fr_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce`)
};

const de_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerce`)
};

const ja_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマース`)
};

const zh_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商务`)
};

const ar_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التجارة`)
};

const id_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdagangan`)
};

const it_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercio`)
};

const ru_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коммерция`)
};

const pt_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comércio`)
};

const ko_commerce = /** @type {(inputs: CommerceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커머스`)
};

/**
* | output |
* | --- |
* | "Commerce" |
*
* @param {CommerceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const commerce = /** @type {((inputs?: CommerceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CommerceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_commerce(inputs)
	if (locale === "es") return es_commerce(inputs)
	if (locale === "fr") return fr_commerce(inputs)
	if (locale === "de") return de_commerce(inputs)
	if (locale === "ja") return ja_commerce(inputs)
	if (locale === "zh") return zh_commerce(inputs)
	if (locale === "ar") return ar_commerce(inputs)
	if (locale === "id") return id_commerce(inputs)
	if (locale === "it") return it_commerce(inputs)
	if (locale === "ru") return ru_commerce(inputs)
	if (locale === "pt") return pt_commerce(inputs)
	return ko_commerce(inputs)
});